<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="flex min-h-dvh items-center justify-center bg-muted p-4">
        <div class="w-full max-w-sm">
            <div class="mb-6 flex items-center justify-center gap-2">
                <UIcon name="i-lucide-building-2" class="size-7 text-primary" />
                <span class="text-lg font-semibold text-highlighted">{{ $t('app.name') }}</span>
            </div>

            <slot>
                <RouterView />
            </slot>

            <p class="mt-6 text-center text-xs text-dimmed">
                {{ $t('app.product') }} · {{ version }}
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'

    const version = computed(() => __APP_VERSION__.startsWith('v') ? __APP_VERSION__ : `v${__APP_VERSION__}`)
</script>
